import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import ThemeWrapper from './ProviderWrapper/ThemeWrapper';

export default function ProviderWrapper({
  store,
  applicationName,
  children,
  alwaysRender,
}) {
  return (
    <Provider store={store}>
      <ThemeWrapper
        applicationName={applicationName}
        alwaysRender={alwaysRender}
      >
        {children}
      </ThemeWrapper>
    </Provider>
  );
}

ProviderWrapper.propTypes = {
  applicationName: PropTypes.string.isRequired,
  store: PropTypes.shape({
    dispatch: PropTypes.func.isRequired,
    getState: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  alwaysRender: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

ProviderWrapper.defaultProps = {
  children: [],
  alwaysRender: [],
};
